/*!
 * Music Forecast — ソフトナビゲーション
 * ページ遷移でドキュメントを作り直さず、main の中身だけ差し替える。
 * これにより body 直下の #mf-yt（YouTube iframe）が破棄されず、再生が途切れない。
 *
 * 置き場所 : テーマ → コードを編集 → Assets → mf-softnav.js
 * 読み込み : layout/theme.liquid の </body> 直前に
 *            <script src="{{ 'mf-softnav.js' | asset_url }}" defer></script>
 *
 * 無効化   : URL に ?nosoftnav=1 を付ける / localStorage.mfSoftNavOff = '1'
 *
 * 前提（2026-09-17 に本番で確認済み）
 *   - 差し替え領域は main#MainContent、プレイヤーは body 直下の #mf-yt と #mf-player
 *   - Shopify.theme.sections.registered[type] がセクションのコンストラクタ
 *   - Alpine 2.8.2（discoverUninitializedComponents / initializeComponent あり）
 *   - main 内の script は application/json と ld+json のみ（実行コード無し）
 *
 * 2026-09-19 修正: コレクション2ページ目以降 → 商品 → 戻る で1ページ目に戻ってしまう不具合
 *   原因: テーマの filterable セクション（Alpine）が mounted() で window に popstate リスナーを登録し、
 *         e.state.searchParams（テーマ自身のフィルタ状態）を読んで AJAX で再描画する。
 *         ソフトナビの state には searchParams が無いため "" と解釈され、1ページ目が描画されていた。
 *         さらにソフトナビで差し替えるたびに新しい filterable が mount され、リスナーが増え続けていた。
 *   対策: (1) 初回読み込み時に mount 済みの filterable の renderPage を包み、ソフトナビの履歴では何もしないようにする
 *            （テーマのリスナーはソフトナビより先に登録されているため、イベント側からは止められない）
 *         (2) 差し替え中に登録される popstate リスナーを捨てる（増殖防止）
 *         (3) 保険として state に searchParams（URL のクエリ）を持たせ、万一テーマ側が描画しても正しいページになるようにする
 */
(function () {
  'use strict';

  if (window.__mfSoftNav) return;
  if (!window.history || !window.fetch || !window.DOMParser) return;
  try { if (localStorage.getItem('mfSoftNavOff') === '1') return; } catch (e) {}
  if (/[?&]nosoftnav=1/.test(location.search)) return;
  if (window.Shopify && window.Shopify.designMode) return;   // テーマエディタでは動かさない
  window.__mfSoftNav = true;

  var MAIN = 'main#MainContent';
  function log() { try { console.log.apply(console, ['[softnav]'].concat([].slice.call(arguments))); } catch (e) {} }
  var CACHE = {};          // URL → HTML（hover 先読み）
  var CACHE_MAX = 12;
  var busy = null;         // 実行中の AbortController

  /* ソフトナビが history に書く state。
     searchParams はテーマの filterable が popstate で読む項目（フィルタ・並べ替え・page）。
     万一テーマのリスナーが先に動いても、正しいページを描画させるために URL のクエリをそのまま渡す */
  function stateFor(y, search) {
    var q = (search == null ? location.search : search) || '';
    if (q.charAt(0) === '?') q = q.slice(1);
    return { mf: 1, y: y || 0, searchParams: q };
  }

  /* 初回読み込みで mount 済みの filterable（テーマ）の popstate 処理を無効にする。
     テーマは mounted() で window に popstate リスナーを登録し、onHistoryChange → this.renderPage(params, null, false) を呼ぶ。
     このリスナーはソフトナビより先に登録されているため、イベントの伝播では止められない。
     代わりに、Alpine コンポーネントの renderPage を包み、「URL 更新なし（第3引数 false）かつソフトナビの履歴」のときは何もしない。
     フィルタ・並べ替えのフォーム送信（第3引数なし）はそのまま通す。
     差し替え後に mount される filterable はリスナー登録自体を捨てるので（swap 内）、ここで扱うのは初回の1つだけ */
  function muteThemeHistory() {
    var els = document.querySelectorAll('[data-section-type="filterable"]');
    for (var i = 0; i < els.length; i++) {
      var c = els[i].__x;
      var d = c && (c.unobservedData || c.$data);
      if (!d || typeof d.renderPage !== 'function' || d.__mfMuted) continue;
      (function (data, orig) {
        data.renderPage = function (params, ev, updateUrl) {
          if (updateUrl === false && history.state && history.state.mf) {
            if (window.mfSoftNavDebug) log('mute theme renderPage on popstate');
            return;
          }
          return orig.apply(this, arguments);
        };
        data.__mfMuted = true;
      })(d, d.renderPage);
    }
  }

  /* ---------------------------------------------------------------- 対象の判定 */

  // ここ以外は通常のページ遷移に任せる
  var DENY = /\/(cart|checkout|account|challenge|orders|apps|tools|services|localization|password)(\/|$|\?)|\/\.well-known|\/admin/;
  var ALLOW = /^\/(en\/)?(collections|products|pages|blogs|search)(\/|$|\?)|^\/(en)?\/?$/;

  function sameOrigin(a) {
    return a.protocol === location.protocol && a.host === location.host;
  }

  function navigable(a, e) {
    if (!a || !a.href) return false;
    if (e && (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return false;
    if (a.hasAttribute('download') || a.target && a.target !== '_self') return false;
    if (!sameOrigin(a)) return false;
    if (a.getAttribute('href').charAt(0) === '#') return false;
    if (a.pathname === location.pathname && a.search === location.search) return false;
    if (DENY.test(a.pathname)) return false;
    if (!ALLOW.test(a.pathname)) return false;
    // プレイヤーの操作、フォーム内のリンク（フィルタ・並べ替えはテーマが自前で AJAX する）は触らない
    if (a.closest('#mf-player, .mf-listen, .mf-play, .mf-playall, form')) return false;
    if (a.hasAttribute('data-no-softnav')) return false;
    return true;
  }

  /* ---------------------------------------------------------------- 進行表示 */

  var bar;
  function barStart() {
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'mf-softnav-bar';
      bar.style.cssText = 'position:fixed;top:0;left:0;height:2px;width:0;background:#161819;' +
        'z-index:99999;transition:width .25s ease,opacity .3s;pointer-events:none;opacity:0';
      document.body.appendChild(bar);
    }
    bar.style.transition = 'none';  bar.style.width = '0';  bar.style.opacity = '1';
    void bar.offsetWidth;
    bar.style.transition = 'width 1.2s cubic-bezier(.2,.8,.2,1)';
    bar.style.width = '75%';
  }
  function barDone() {
    if (!bar) return;
    bar.style.transition = 'width .2s ease, opacity .35s .15s';
    bar.style.width = '100%';  bar.style.opacity = '0';
  }

  /* ---------------------------------------------------------------- 取得 */

  function fetchPage(url) {
    if (CACHE[url]) return Promise.resolve(CACHE[url]);
    if (busy) { try { busy.abort(); } catch (e) {} }
    busy = ('AbortController' in window) ? new AbortController() : null;
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'mf-softnav' },
      signal: busy ? busy.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.text();
    }).then(function (html) {
      var keys = Object.keys(CACHE);
      if (keys.length >= CACHE_MAX) delete CACHE[keys[0]];
      CACHE[url] = html;
      return html;
    });
  }

  function prefetch(url) {
    if (CACHE[url]) return;
    fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'mf-softnav' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { if (t) CACHE[url] = t; })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------- 差し替え */

  var S = function () { return (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) || null; };

  function unloadSections(root) {
    var s = S(); if (!s || !s.instances) return;
    var els = root.querySelectorAll('[data-section-type]');
    for (var i = 0; i < els.length; i++) {
      for (var j = s.instances.length - 1; j >= 0; j--) {
        if (s.instances[j].container === els[i]) {
          try { if (typeof s.instances[j].onUnload === 'function') s.instances[j].onUnload(); } catch (e) {}
          s.instances.splice(j, 1);
        }
      }
    }
  }

  function loadSections(root) {
    var s = S(); if (!s || !s.registered) return;
    var els = root.querySelectorAll('[data-section-type]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], type = el.getAttribute('data-section-type');
      var C = s.registered[type];
      if (typeof C !== 'function') continue;
      var dup = false;
      for (var j = 0; j < s.instances.length; j++) if (s.instances[j].container === el) { dup = true; break; }
      if (dup) continue;
      // セクションの onLoad が window.ThemeSection_* を定義する。これが Alpine より先に要る
      try { s.instances.push(new C(el)); } catch (e) { if (window.mfSoftNavDebug) console.warn('[softnav] section', type, e); }
    }
  }

  function runInlineScripts(root) {
    // 通常 main 内は JSON だけだが、将来テーマが実行コードを入れた場合の保険
    var list = root.querySelectorAll('script');
    for (var i = 0; i < list.length; i++) {
      var s = list[i], t = (s.type || '').toLowerCase();
      if (t && t.indexOf('json') > -1) continue;
      if (s.src) continue;
      var n = document.createElement('script');
      n.textContent = s.textContent;
      s.parentNode.replaceChild(n, s);
    }
  }

  /* 差し替える1区画分の下準備。Alpine が挿入直後に動き出さないよう x-data を退避する。
     セクションの onLoad より先に評価されると ThemeSection_* 未定義で落ちるため */
  function hold(el) {
    var xs = el.querySelectorAll('[x-data]');
    for (var i = 0; i < xs.length; i++) {
      xs[i].setAttribute('data-mf-x', xs[i].getAttribute('x-data'));
      xs[i].removeAttribute('x-data');
    }
  }
  function release(el) {
    var xs = el.querySelectorAll('[data-mf-x]');
    for (var i = 0; i < xs.length; i++) {
      xs[i].setAttribute('x-data', xs[i].getAttribute('data-mf-x'));
      xs[i].removeAttribute('data-mf-x');
    }
  }
  function copyAttrs(cur, nu) {
    var keepId = cur.id;
    while (cur.attributes.length) cur.removeAttribute(cur.attributes[0].name);
    for (var i = 0; i < nu.attributes.length; i++) cur.setAttribute(nu.attributes[i].name, nu.attributes[i].value);
    if (!cur.id) cur.id = keepId;
  }

  /* body 直下で、ページによって中身が変わる区画を拾う。
     ヘッダーはトップページだけ大きなバナーを持つため、main だけ差し替えると
     トップから移動したときにバナーが残る（2026-09-17 に本番で発生）。
     アプリのブロック（.shopify-block）は第三者のスクリプトが二重に動く恐れがあるので触らない */
  function regions(doc) {
    var out = [];
    var nodes = doc.querySelectorAll('body > .shopify-section');
    for (var i = 0; i < nodes.length; i++) {
      var nu = nodes[i];
      if (!nu.id) continue;
      var cur = document.getElementById(nu.id);
      if (!cur || cur === nu) continue;
      if (cur.innerHTML === nu.innerHTML) continue;     // 同じなら触らない（通常はヘッダーもフッターも同じ）
      out.push({ cur: cur, nu: nu });
    }
    return out;
  }

  function swap(html, url) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nm = doc.querySelector(MAIN), main = document.querySelector(MAIN);
    if (!nm || !main) return false;

    var parts = [{ cur: main, nu: nm }].concat(regions(doc));
    if (window.mfSoftNavDebug) log('swap', url, parts.map(function (p) { return p.cur.id || 'main'; }));

    // 1. 退避してから、まとめて中身を入れ替える
    var i;
    for (i = 0; i < parts.length; i++) {
      hold(parts[i].nu);
      unloadSections(parts[i].cur);
      copyAttrs(parts[i].cur, parts[i].nu);
      parts[i].cur.innerHTML = parts[i].nu.innerHTML;
    }

    // 2. body のクラスと ID（template-product / template-collection 等。配色とレイアウトが依存する）
    var nb = doc.body;
    if (nb) {
      document.body.className = nb.className;
      document.body.id = nb.id;
      for (var b = 0; b < nb.attributes.length; b++) {
        var at = nb.attributes[b];
        if (at.name !== 'class' && at.name !== 'id') document.body.setAttribute(at.name, at.value);
      }
    }

    // 3. head の主要タグ
    document.title = doc.title || document.title;
    copyMeta(doc, 'link[rel="canonical"]', 'href');
    copyMeta(doc, 'meta[name="description"]', 'content');

    // 4. セクションを読み込む。ヘッダーの onLoad は MainContent の中を見るので、
    //    すべての中身を入れ替え終わってから走らせる必要がある
    //    この間に登録される popstate リスナー（filterable の mounted）は捨てる。
    //    戻る/進むはソフトナビが丸ごと差し替えるので不要で、残すと差し替えのたびに増えて多重 fetch になる
    var origAdd = window.addEventListener;
    window.addEventListener = function (type) {
      if (type === 'popstate') { if (window.mfSoftNavDebug) log('drop popstate listener'); return; }
      return origAdd.apply(window, arguments);
    };
    try {
      for (i = 0; i < parts.length; i++) { runInlineScripts(parts[i].cur); loadSections(parts[i].cur); }

      // 5. x-data を戻して Alpine に初期化させる
      for (i = 0; i < parts.length; i++) release(parts[i].cur);
      try {
        window.Alpine.discoverUninitializedComponents(function (c) { window.Alpine.initializeComponent(c); });
      } catch (e) { if (window.mfSoftNavDebug) console.warn('[softnav] alpine', e); }
    } finally {
      window.addEventListener = origAdd;
    }

    // 6. 遅延読み込みと in-view 演出を作動させる
    try { window.dispatchEvent(new CustomEvent('label:section:hasmutated', { detail: { url: url } })); } catch (e) {}
    try { if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems(); } catch (e) {}

    pageview();
    try { document.dispatchEvent(new CustomEvent('mf:softnav', { detail: { url: url } })); } catch (e) {}
    return true;
  }

  function copyMeta(doc, selector, attr) {
    var src = doc.querySelector(selector), cur = document.querySelector(selector);
    if (!src) return;
    if (cur) cur.setAttribute(attr, src.getAttribute(attr));
    else document.head.appendChild(src.cloneNode(true));
  }

  function pageview() {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'page_view', { page_location: location.href, page_path: location.pathname, page_title: document.title }); } catch (e) {}
    try { if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.page) window.ShopifyAnalytics.lib.page(null, { path: location.pathname, title: document.title }); } catch (e) {}
    try { if (window.fbq) window.fbq('track', 'PageView'); } catch (e) {}
  }

  /* ---------------------------------------------------------------- 遷移 */

  function saveScroll() {
    try { history.replaceState(stateFor(window.scrollY), '', location.href); } catch (e) {}
  }

  function go(url, push, restoreY) {
    barStart();
    fetchPage(url).then(function (html) {
      if (!swap(html, url)) { location.href = url; return; }
      if (push) {
        history.pushState(stateFor(0, url.indexOf('?') > -1 ? url.slice(url.indexOf('?')) : ''), '', url);
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, restoreY || 0);
      }
      barDone();
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      location.href = url;    // 何かあれば通常遷移に落とす
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!navigable(a, e)) return;
    e.preventDefault();
    saveScroll();
    go(a.pathname + a.search, true);
  });

  // hover / タッチ開始で先読み
  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!navigable(a)) return;
    clearTimeout(hoverTimer);
    var u = a.pathname + a.search;
    hoverTimer = setTimeout(function () { prefetch(u); }, 90);
  });
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (navigable(a)) prefetch(a.pathname + a.search);
  }, { passive: true });

  // キャプチャ段階で登録する。ブラウザによっては先に登録済みのテーマのリスナーより前に動けるが、
  // Chromium では登録順のまま（テーマが先）だったため、主対策は muteThemeHistory と swap 内のリスナー破棄。
  // ここの stopImmediatePropagation は、後から登録されたリスナーを止めるための保険
  window.addEventListener('popstate', function (e) {
    if (!e.state) { location.reload(); return; }          // 誰の状態でもない履歴は通常の再読み込み
    if (!e.state.mf) return;                               // テーマ自身の状態（フィルタ・並べ替え）はテーマに任せる
    e.stopImmediatePropagation();                          // テーマの filterable による再描画を止める
    go(location.pathname + location.search, false, e.state.y || 0);
  }, true);

  // 最初のページにも状態を持たせる（戻ったときに reload しないため）
  try { history.replaceState(stateFor(0), '', location.href); } catch (e) {}

  // 初回の filterable を黙らせる。Alpine の初期化がこのスクリプトより後になる場合に備えて数回試す
  muteThemeHistory();
  document.addEventListener('DOMContentLoaded', muteThemeHistory);
  window.addEventListener('load', muteThemeHistory);
  setTimeout(muteThemeHistory, 1500);
})();